/* import __COLOCATED_TEMPLATE__ from './confirm-save-body.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();